import { jsx as _jsx } from "react/jsx-runtime";
import { AccentText } from '../../atoms/AccentText/AccentText';
import { Text } from '../../atoms/Text/Text';
export const Label = ({ children, isAccentText, isBold, renderAs, size, ...props })=>{
    const as = renderAs ? renderAs : 'label';
    return isAccentText ? /*#__PURE__*/ _jsx(AccentText, {
        renderAs: as,
        size: size,
        ...props,
        children: children
    }) : /*#__PURE__*/ _jsx(Text, {
        isBold: isBold,
        renderAs: as,
        size: size,
        ...props,
        children: children
    });
};

//# sourceMappingURL=Label.js.map